<div class="p-3 mb-4 bg-light rounded-3">
    <div class="row">
        <div class="col-12 mb-3">
            <div class="titletoptables">
                <div class="leftsideicons">
                    <img src="../../assets/image/general-setting-icon.png" alt="settings" />
                </div>
                <h3>{{ "Settings" }}</h3>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-lg-3">
            <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                <button class="nav-link active" id="v-pills-profile-tab" data-bs-toggle="pill"
                    data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile"
                    aria-selected="true">
                    Profile
                </button>
                <button class="nav-link" id="v-pills-pass-tab" data-bs-toggle="pill" data-bs-target="#v-pills-pass"
                    type="button" role="tab" aria-controls="v-pills-pass" aria-selected="false">
                    Password
                </button>
                <button *ngIf="isAdmin" class="nav-link" id="v-pills-user-tab" data-bs-toggle="pill"
                    data-bs-target="#v-pills-user" type="button" role="tab" aria-controls="v-pills-user"
                    aria-selected="false" (click)="getAllUsers()">
                    User
                </button>
            </div>
        </div>
        <div class="col-12 col-lg-9">
            <div class="card personal shadow-sm p-4">
                <div class="tab-content" id="v-pills-tabContent">
                    <div class="tab-pane fade show active" id="v-pills-profile" role="tabpanel"
                        aria-labelledby="v-pills-profile-tab">
                        <h4 class="mb-3">Profile</h4>
                        <form [formGroup]="profileForm" class="profile-form">
                            <!-- Profile Image Upload -->
                            <div class="form-group">
                                <div *ngIf="ImageUrl" class="image-preview">
                                    <img [src]="ImageUrl" alt="Client Profile" class="profile-image" />
                                </div>
                                <mat-form-field class="w-100 custom-blue">
                                    <input type="file" matInput formControlName="image" accept="image/*"
                                        (change)="changeListener($event)" />
                                </mat-form-field>
                            </div>

                            <!-- Name -->
                            <mat-form-field class="w-100 custom-blue">
                                <mat-label>Name</mat-label>
                                <input matInput type="text" formControlName="name" placeholder="Enter Your Name"
                                    maxlength="30" required
                                    [ngClass]="{ 'is-invalid': profileForm.controls['name'].errors }" />
                                <mat-error *ngIf="profileForm.controls['name'].errors?.['required']">
                                    Name is required
                                </mat-error>
                            </mat-form-field>

                            <!-- Email -->
                            <mat-form-field class="w-100 custom-blue">
                                <mat-label>Email</mat-label>
                                <input matInput type="text" formControlName="email" placeholder="Enter Your Email"
                                    required maxlength="50"
                                    [ngClass]="{ 'is-invalid': profileForm.controls['email'].errors }" />
                                <mat-error *ngIf="profileForm.controls['email'].errors?.['required']">
                                    Email is required
                                </mat-error>
                                <mat-error *ngIf="profileForm.controls['email'].errors?.['pattern']">
                                    Please follow standard email pattern
                                </mat-error>
                            </mat-form-field>

                            <!-- Submit Button -->
                            <button mat-raised-button type="button" class="btn btn-primary" (click)="onUploadProfile()">
                                Submit
                            </button>
                        </form>
                    </div>

                    <div class="tab-pane fade" id="v-pills-pass" role="tabpanel" aria-labelledby="v-pills-pass-tab">
                        <h4 class="mb-3">Password</h4>
                        <form [formGroup]="passwordChangeForm" (ngSubmit)="onChangePwd()" class="profile-form">
                            <!-- Email Address -->
                            <mat-form-field class="w-100 custom-blue">
                                <mat-label>Email Address</mat-label>
                                <input matInput type="text" formControlName="email" placeholder="Enter Your Email"
                                    maxlength="50" [ngClass]="{ 'is-invalid': submitted && f['email'].errors }" />
                                <mat-error *ngIf="submitted && f['email'].errors?.['required']">
                                    Email is required
                                </mat-error>
                                <mat-error *ngIf="submitted && f['email'].errors?.['pattern']">
                                    Please follow standard email pattern
                                </mat-error>
                            </mat-form-field>

                            <!-- Old Password -->
                            <mat-form-field class="w-100 custom-blue">
                                <mat-label>Old Password</mat-label>
                                <input matInput type="password" formControlName="password1"
                                    placeholder="Enter Your Old Password" minlength="6"
                                    [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" />
                                <mat-error *ngIf="submitted && f['password1'].errors?.['required']">
                                    Old Password is required
                                </mat-error>
                                <mat-error *ngIf="submitted && f['password'].errors?.['minlength']">
                                    Old Password min length should be 6 characters
                                </mat-error>
                            </mat-form-field>

                            <!-- New Password -->
                            <mat-form-field class="w-100 custom-blue">
                                <mat-label>New Password</mat-label>
                                <input matInput type="password" formControlName="password"
                                    placeholder="Enter Your New Password" minlength="6"
                                    [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" />
                                <mat-error *ngIf="submitted && f['password'].errors?.['required']">
                                    New Password is required
                                </mat-error>
                                <mat-error *ngIf="submitted && f['password'].errors?.['minlength']">
                                    New Password min length should be 6 characters
                                </mat-error>
                            </mat-form-field>

                            <!-- Confirm Password -->
                            <mat-form-field class="w-100 custom-blue">
                                <mat-label>Confirm Password</mat-label>
                                <input matInput type="password" id="confirmPassword" formControlName="confirmPassword"
                                    placeholder="Enter Your Confirm Password" minlength="6"
                                    [ngClass]="{ 'is-invalid': submitted && f['confirmPassword'].errors }" />
                                <mat-error *ngIf="submitted && f['confirmPassword'].errors?.['required']">
                                    Confirm Password is required
                                </mat-error>
                                <mat-error *ngIf="f['confirmPassword'].errors?.['minlength']">
                                    Confirm min length should be 6 characters
                                </mat-error>
                                <mat-error *ngIf="f['confirmPassword'].errors?.['matching']">
                                    Password and Confirm Password must match
                                </mat-error>
                            </mat-form-field>

                            <!-- Submit Button -->
                            <button mat-raised-button type="button" class="btn btn-primary" type="submit">
                                Submit
                            </button>
                        </form>
                    </div>

                    <div class="tab-pane fade" id="v-pills-user" role="tabpanel" aria-labelledby="v-pills-user-tab">
                        <div class="heading-container">
                            <h4 class="mb-3">User</h4>
                            <div class="d-flex">
                                <div class="srchgrid texttarget">
                                    <input class="searchtextbox" matInput
                                        (keyup)="filterData($any($event.target).value)" [value]="searchText"
                                        placeholder="Search" autocomplete="off">
                                    <div class="closeicon" (keydown.enter)="clearList()" (click)="clearList()">
                                        <span aria-hidden="true">&times;</span>
                                    </div>
                                </div>
                                <button class="btn btn-primary" (click)="onViewClicked()">Add Admin User</button>
                            </div>
                        </div>
                        <kendo-grid [data]="kendoData" [sort]="state.sort" [resizable]="true" [reorderable]="true"
                            [columnMenu]="{ filter: true }" [filter]="state.filter" [sortable]="true"
                            [pageSize]="state.take" [skip]="state.skip" [group]="state.group" [filterable]="false"
                            [pageable]="kendoData?.data?.length && kendoData.data.length > 0 ? pageableWithAll : false"
                            (dblclick)="onRowDoubleClick($event)" [groupable]="true"
                            (dataStateChange)="!!kendoData ? dataStateChange($event) : null">
                            <kendo-grid-column field="Action" [width]="100" title="Action" [sortable]="false"
                                [groupable]="false" [filterable]="false" [columnMenu]="false">
                                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                                    <div class="d-flex">
                                        <div class="mx-2">
                                            <button class="verical_menu" type="button" id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src="/assets/image/vertical-icon.png" alt="" class="vertical">
                                            </button>
                                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li class="cursor-pointer">
                                                    <a class="dropdown-item" (keydown.enter)="onViewClicked(dataItem)"
                                                        (click)="onViewClicked(dataItem)" data-bs-toggle="modal"
                                                        data-bs-target="#exampleModal">
                                                        <img src="../../assets/image/edit-appointment-icon.png"
                                                            alt="Edit" class="ico20 me-2">Edit</a>
                                                </li>
                                                <li class="cursor-pointer">
                                                    <a class="dropdown-item" (keydown.enter)="onDelete(dataItem.Id)"
                                                        (click)="onDelete(dataItem.Id)" data-bs-toggle="modal"
                                                        data-bs-target="#exampleModal">
                                                        <img src="../../assets/image/delete-appointment-icon.png"
                                                            alt="Delete" class="ico20 me-2">Delete</a>
                                                </li>
                                                <li class="cursor-pointer">
                                                    <a class="dropdown-item"
                                                        (keydown.enter)="onResetPasswordClicked(dataItem.Id)"
                                                        (click)="onResetPasswordClicked(dataItem.Id)"
                                                        data-bs-toggle="modal" data-bs-target="#exampleModal">
                                                        <img src="../../assets/image/reset-password.png" alt="Delete"
                                                            class="ico20 me-2">Reset Password</a>
                                                </li>
                                                <li class="cursor-pointer">
                                                    <a class="dropdown-item">
                                                        <mat-slide-toggle class="toggle" [(ngModel)]="dataItem.IsActive"
                                                            *ngIf="!dataItem.IsAdmin"
                                                            (change)="onToggleStatus(dataItem)">
                                                        </mat-slide-toggle>Active</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column field="fullname" title="Full Name">
                            </kendo-grid-column>
                            <kendo-grid-column field="email" title="Email"></kendo-grid-column>
                            <kendo-grid-column field="createdDate" title="Created Date" [width]="150">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    {{ dataItem.createdDate }}
                                </ng-template>
                            </kendo-grid-column>
                        </kendo-grid>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #addEditDialog>
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2 class="popup-title">
                            {{ action ? 'Add' : 'Update' }} User
                        </h2>
                        <button type="button" class="btn-close" mat-dialog-close data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <mat-dialog-content>
                            <form [formGroup]="userForm">
                                <div class="row">
                                    <!-- First Name -->
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100 custom-blue">
                                            <mat-label>First Name</mat-label>
                                            <input matInput formControlName="firstName"
                                                placeholder="Enter your first name" required maxlength="30" />
                                            <mat-error *ngIf="isSubmitted && userForm.get('firstName')?.errors">
                                                <ng-container *ngIf="userForm.get('firstName')?.errors?.['required']">
                                                    First Name is required
                                                </ng-container>
                                                <ng-container *ngIf="userForm.get('firstName')?.errors?.['pattern']">
                                                    Please enter a valid name.
                                                </ng-container>
                                                <ng-container *ngIf="userForm.get('firstName')?.errors?.['maxlength']">
                                                    Max 30 characters allowed
                                                </ng-container>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Last Name -->
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100 custom-blue">
                                            <mat-label>Last Name</mat-label>
                                            <input matInput formControlName="lastName"
                                                placeholder="Enter your last name" maxlength="30" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <!-- Email -->
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="email" placeholder="Enter your email"
                                        maxlength="30" required />
                                    <mat-error *ngIf="isSubmitted && userForm.get('email')?.errors">
                                        <ng-container *ngIf="userForm.get('email')?.errors?.['required']">
                                            Email is required
                                        </ng-container>
                                        <ng-container *ngIf="userForm.get('email')?.errors?.['pattern']">
                                            Invalid email format
                                        </ng-container>
                                    </mat-error>
                                </mat-form-field>

                                <!-- Passwords (only if action = true) -->
                                <ng-container *ngIf="action">
                                    <!-- Password -->
                                    <mat-form-field class="w-100 custom-blue">
                                        <mat-label>Password</mat-label>
                                        <input matInput type="password" formControlName="password"
                                            placeholder="Enter your password" />
                                        <mat-error *ngIf="isSubmitted && userForm.get('password')?.errors">
                                            <ng-container *ngIf="userForm.get('password')?.errors?.['required']">
                                                Password is required
                                            </ng-container>
                                            <ng-container *ngIf="userForm.get('password')?.errors?.['minlength']">
                                                Minimum 6 characters required
                                            </ng-container>
                                            <ng-container *ngIf="userForm.get('password')?.errors?.['pattern']">
                                                Please enter a valid password.
                                            </ng-container>
                                        </mat-error>
                                    </mat-form-field>

                                    <!-- Confirm Password -->
                                    <mat-form-field class="w-100">
                                        <mat-label>Confirm Password</mat-label>
                                        <input matInput type="password" formControlName="confirmPassword"
                                            placeholder="Enter your confirm password" />
                                        <mat-error *ngIf="isSubmitted && userForm.get('confirmPassword')?.errors">
                                            <ng-container *ngIf="userForm.get('confirmPassword')?.errors?.['required']">
                                                Confirm password is required
                                            </ng-container>
                                            <ng-container
                                                *ngIf="userForm.get('confirmPassword')?.errors?.['minlength']">
                                                Minimum 6 characters required
                                            </ng-container>
                                            <ng-container *ngIf="userForm.get('confirmPassword')?.errors?.['matching']">
                                                Passwords do not match
                                            </ng-container>
                                        </mat-error>
                                    </mat-form-field>
                                </ng-container>
                            </form>

                        </mat-dialog-content>
                        <mat-dialog-actions align="end">
                            <button mat-raised-button class="btn btn-secondary cancel-button"
                                mat-dialog-close>Cancel</button>
                            <button mat-raised-button class="btn btn-primary" (click)="submitUser()">{{ action ? 'Add' :
                                'Update' }}</button>
                        </mat-dialog-actions>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #deleteDialog>
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="popup-title">Delete Confirmation</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            mat-dialog-close></button>
                    </div>
                    <div class="modal-body">
                        <mat-dialog-content>
                            <div>Are you sure you want to delete this user?</div>
                        </mat-dialog-content>
                        <mat-dialog-actions align="end">
                            <button mat-raised-button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                tabindex="-1" mat-dialog-close>No</button>
                            <button mat-raised-button type="button" (click)="deleteUser()" class="btn btn-primary"
                                data-bs-toggle="modal" tabindex="0">Yes</button>
                        </mat-dialog-actions>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #updateStatusDialog>
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="popup-title">Update Status</h4>
                        <button type="button" class="btn-close" aria-label="Close" mat-dialog-close
                            (click)="Noupdate()"></button>
                    </div>
                    <div class="modal-body">
                        <mat-dialog-content>
                            <div>Are you sure you want to update status of this user?</div>
                        </mat-dialog-content>
                        <mat-dialog-actions align="end">
                            <button mat-raised-button type="button" class="btn btn-secondary" tabindex="-1"
                                (click)="Noupdate()" mat-dialog-close>No</button>
                            <button mat-raised-button type="button" (click)="updateStatusUser()" class="btn btn-primary"
                                data-bs-toggle="modal" tabindex="0">Yes</button>
                        </mat-dialog-actions>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #resetPasswordDialog>
            <div class="modal-dialog">
                <div class="modal-content">

                    <!-- Header -->
                    <div class="modal-header">
                        <h4 class="popup-title">
                            Change Password
                        </h4>

                        <button type="button" class="btn-close" mat-dialog-close data-bs-dismiss="modal"
                            aria-label="Close">
                        </button>
                    </div>

                    <!-- Body -->
                    <div class="modal-body">
                        <mat-dialog-content>
                            <form [formGroup]="resetPassowrdForm" autocomplete="off">
                                <!-- Password -->
                                <div class="form-group">
                                    <mat-form-field class="example-full-width saveInput">
                                        <mat-label>Password</mat-label>
                                        <input matInput type="password" formControlName="NewPassword"
                                            placeholder="Enter your password" autocomplete="off" />

                                        <mat-error
                                            *ngIf="isSubmitted && resetPassowrdForm.get('NewPassword')?.errors?.['required']">
                                            Password is required
                                        </mat-error>

                                        <mat-error
                                            *ngIf="isSubmitted && resetPassowrdForm.get('NewPassword')?.errors?.['pattern']">
                                            Please enter a valid password.
                                        </mat-error>

                                        <mat-error
                                            *ngIf="isSubmitted && resetPassowrdForm.get('NewPassword')?.errors?.['minlength']">
                                            Minimum 6 characters required
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <!-- Confirm Password -->
                                <div class="form-group">
                                    <mat-form-field class="example-full-width saveInput">
                                        <mat-label>Confirm Password</mat-label>
                                        <input matInput type="password" formControlName="confirmPassword"
                                            placeholder="Enter your confirm password" autocomplete="off" />

                                        <mat-error
                                            *ngIf="isSubmitted && resetPassowrdForm.get('confirmPassword')?.errors?.['required']">
                                            Confirm password is required
                                        </mat-error>

                                        <mat-error
                                            *ngIf="isSubmitted && resetPassowrdForm.get('confirmPassword')?.errors?.['minlength']">
                                            Minimum 6 characters required
                                        </mat-error>

                                        <mat-error
                                            *ngIf="isSubmitted && resetPassowrdForm.get('confirmPassword')?.errors?.['matching']">
                                            Passwords do not match
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </form>
                        </mat-dialog-content>

                        <!-- Footer -->
                        <mat-dialog-actions align="end">
                            <button type="button" mat-raised-button class="btn btn-secondary" mat-dialog-close>
                                Cancel
                            </button>
                            <button mat-raised-button type="button" class="btn btn-primary" (click)="changePassword()">
                                Update
                            </button>
                        </mat-dialog-actions>

                    </div>
                </div>
            </div>
        </ng-template>